/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { DataFormField, DropDownItem } from '../../../state/data-form.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataFormService } from '../../../services/data-form.service';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'dash-gis-table-db-dropdown',
    templateUrl: './table-db-dropdown.component.html',
    styleUrls: ['./table-dropdown.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TableDbDropdownComponent),
            multi: true,
        },
    ],
    imports: [MatSelect, FormsModule, MatOption, AsyncPipe],
})
export class TableDbDropdownComponent implements ControlValueAccessor {
    // tslint:disable:no-input-rename
    @Input('value') _value: any = '';
    @Input('placeholder') _placeholder = '';
    @Input() formName: string;
    @Input() field: DataFormField;
    @Input() parameterValue: any;
    @Input() required = false;
    @Input() validationPattern: RegExp;
    @Input() validationMessage: string;

    public disabled: boolean;
    public dropdownItems: DropDownItem[];

    constructor(private dataFormService: DataFormService) {}

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    writeValue(value: any): void {
        if (value) {
            this.value = value;
        }
    }

    onChange: any = () => {};
    onTouched: any = () => {};

    public get dropdownOptions$(): Observable<DropDownItem[]> {
        return this.dataFormService.getDropDownOptions$(this.formName, this.field.fieldName, this.parameterValue).pipe(
            map((options) => {
                this.dropdownItems = options;
                return options;
            })
        );
    }

    get value() {
        return this._value;
    }
    set value(val) {
        this._value = val;
        this.onChange(val);
        this.onTouched();
    }

    get placeholder() {
        return this._placeholder;
    }
    set placeholder(val) {
        this._placeholder = val;
        this.onChange(val);
        this.onTouched();
    }
}
